import { compact } from '../../../../helpers/compact';
import { toText } from '../../fields';
import {
  FootnotesSlice,
  LaPosteEn4Type,
} from '../../../../types/LaPosteEn4/slice';
const footnotesSlice = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): FootnotesSlice | undefined =>
  compact({
    type: LaPosteEn4Type.FOOTNOTES,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notes: data.items.map((note: any) =>
      compact({
        reference: toText(note.char),
        description: toText(note.description),
      })
    ),
  });

export default footnotesSlice;
